import { useMemo, useEffect } from "react";

import { googleIdentityModule } from "@/modules/google-identity";
import { useLocation, useNavigate } from "react-router-dom";
import { localStorageModule } from "@/modules/local-storage";
import { atlasRoutes } from "@/app/router/routes";
import { useAtlasAuthContext } from "@/contexts/atlas-auth";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";

export const useGoogleOAuthRedirectPageBehavior = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { authContext } = useAtlasAuthContext();

  const { redirectURI, code } = useMemo(() => {
    const baseUrl = window.location.href;
    const redirectURI = new URL(location.pathname, baseUrl).href;

    const { code } = googleIdentityModule.parseOAuthCode({ location });

    return {
      redirectURI,
      code,
    };
  }, [location]);

  useEffectOnMount(() => {
    authContext.authenticateAccountUsingGoogleOAuthCode({
      code,
      redirectURI,
    });
  });

  useEffect(() => {
    if (!authContext.isAuthenticated) {
      return;
    }

    const asyncLogic = async () => {
      const { pathname } = await localStorageModule.readPendingRedirectPath();
      await localStorageModule.clearPendingRedirectPath();

      const defaultRedirectPath = atlasRoutes.home({}).path;
      const targetPath = pathname ?? defaultRedirectPath;

      /**
       * Using this because we don't have access to the `navigation` store when
       * on a public route.
       */
      navigate(targetPath);
    };

    asyncLogic();
  }, [navigate, authContext.isAuthenticated]);

  return {
    /** @todo - Better handling here. */
    error: false,
  };
};
